import React from 'react';

import Box from '@amzn/meridian/box';
import LoadingSpinnerWrapper from 'src/components/shared/loadingSpinner/loadingSpinnerWrapper';
import PaginationWithDropdown from 'src/components/shared/paginationWithDropdown/paginationWithDropdown';
import { setTaskGroupTableSettings } from 'src/store/adminConfigPageSlice/taskConfigPageSlice/taskConfigPageSlice';
import { useAppDispatch, useAppSelector } from 'src/store/store';

import TaskGroupModal from './taskGroupModal/taskGroupModal';
import TaskGroupTable from './taskGroupTable/taskGroupTable';
import TopOptions from './topOptions/topOptions';

// **** Components **** //

/**
 * TaskGroup Configuration
 */
const TaskGroups = () => {
  const dispatch = useAppDispatch();
  const { isFetchTaskGroupsPending, taskGroupTableSettings } = useAppSelector((state) => state.taskConfigPage);
  const { currentPage, totalPages, perPage } = taskGroupTableSettings;

  return (
    <Box className="view-and-edit-tasks">
      {/* Table */}
      <LoadingSpinnerWrapper showSpinner={isFetchTaskGroupsPending}>
        <TopOptions spacingInset="none none 400 none" />
        <TaskGroupTable />
        <PaginationWithDropdown
          currentPage={currentPage}
          totalPages={totalPages}
          perPage={perPage}
          setPerPage={(perPage) => dispatch(setTaskGroupTableSettings({ perPage }))}
          setCurrentPage={(currentPage) => dispatch(setTaskGroupTableSettings({ currentPage }))}
        />
      </LoadingSpinnerWrapper>

      {/* Modals */}
      <TaskGroupModal />
    </Box>
  );
};

// **** Export **** //

export default TaskGroups;
